import { useFormContainerContext } from '../Services/FormContainerContext';

interface Props {
	name: string;
}

const useFormName = ({ name }: Props) => {
	const { name: formContainerName } = useFormContainerContext();

	const fieldName = formContainerName ? `${formContainerName}.${name}` : name;

	return { fieldName };
};

export default useFormName;
